import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import { jsx, keyframes } from '@emotion/react';
import { forwardRefWithAs } from '@stacks/ui-core';
import { Box } from './box/index.esm.js';
import { VisuallyHidden } from './visually-hidden.esm.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var SpinnerSizes;

(function (SpinnerSizes2) {
  SpinnerSizes2["xs"] = "xs";
  SpinnerSizes2["sm"] = "sm";
  SpinnerSizes2["md"] = "md";
  SpinnerSizes2["lg"] = "lg";
  SpinnerSizes2["xl"] = "xl";
})(SpinnerSizes || (SpinnerSizes = {}));

var spin = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject());

var getSize = function getSize(size) {
  switch (size) {
    case "xs":
      return "0.75rem";

    case "sm":
      return "1rem";

    case "md":
      return "1.5rem";

    case "lg":
      return "2rem";

    case "xl":
      return "3rem";

    default:
      return size;
  }
};

var Spinner = /*#__PURE__*/forwardRefWithAs(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Loading..." : _ref$label,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? "2px" : _ref$thickness,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? "0.85s" : _ref$speed,
      color = _ref.color,
      _ref$emptyColor = _ref.emptyColor,
      emptyColor = _ref$emptyColor === void 0 ? "transparent" : _ref$emptyColor,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "label", "thickness", "speed", "color", "emptyColor"]);

  var _size = getSize(size);

  return /* @__PURE__ */jsx(Box, _extends({
    ref: ref,
    display: "inline-block",
    borderWidth: thickness,
    borderColor: "currentColor",
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    borderRadius: "100%",
    color: color,
    size: _size,
    animation: spin + " " + speed + " linear infinite"
  }, props), label && /* @__PURE__ */jsx(VisuallyHidden, null, label));
});
Spinner.displayName = "Spinner";

export { Spinner, SpinnerSizes };
//# sourceMappingURL=spinner.esm.js.map
